<script lang="ts" setup>
import { inject } from 'vue'
import type { ChapterConfig } from '@/composables/payment'

interface Props {
  chapter: any
  showRecommend: boolean
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'prev-chapter'): void
  (e: 'next-chapter'): void
  (e: 'open-toc'): void
  (e: 'unlock-chapter'): void
}>()

const config = inject<ChapterConfig>('chapterConfig')!

function handlePrev() {
  emit('prev-chapter')
}

function handleNext() {
  emit('next-chapter')
}

function handleOpenTOC() {
  emit('open-toc')
}

function handleUnlock() {
  emit('unlock-chapter')
}
</script>

<template>
  <div class="mt-5 flex items-center gap-10px">
    <!-- Prev 按钮 -->
    <span
      class="chapter-nav-btn flex-1 h-39px lh-39px text-center text-14px rounded-full"
      :class="{ 'is-disabled': !chapter?.prev }" @click.stop="handlePrev"
    >
      {{ config.texts.prevButton }}
    </span>

    <!-- Catalogue 按钮 -->
    <span class="chapter-nav-btn flex-1 h-39px lh-39px text-center text-14px rounded-full" @click.stop="handleOpenTOC">
      {{ config.texts.catalogueButton }}
    </span>

    <!-- Next/Unlock 按钮 -->
    <span
      v-if="!showRecommend"
      class="chapter-nav-btn flex-1 h-39px lh-39px text-center text-14px rounded-full"
      @click.stop="handleNext"
    >
      {{ config.texts.nextButton }}
    </span>
    <span
      v-else
      class="chapter-nav-btn flex-1 h-39px lh-39px text-center text-14px rounded-full"
      :class="{ 'is-disabled': !chapter?.next }"
      @click.stop="handleUnlock"
    >
      {{ config.texts.unlockButton }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.chapter-nav-btn {
  background: var(--theme-nav-btn-bg, rgba(0, 0, 0, 0.04));
  color: var(--theme-nav-btn-color, #65686F);
  cursor: pointer;

  &.is-disabled {
    opacity: 0.5;
  }
}
</style>
